import { Container } from "@pixi/react";
import { gameModuleStore } from "./store/gameModuleStore";
import { GameBoard } from "./components/gameBoard";
import { ReelContainer } from "./components/reelContainer";
import { useLayoutEffect } from "react";
import { LinesIcon } from "./components/linesIcon";
import { isMobile } from "../helpers/isMobile";

export const GameModule = (props) => {
    const { getPropsFromFrame } = gameModuleStore
    useLayoutEffect(() => {
        getPropsFromFrame({ ...props })
    }, [])


    return <Container>
        {!isMobile() && <LinesIcon />}
        <GameBoard />
        <ReelContainer />
    </Container>
} 